import { render, staticRenderFns } from "./ConfigQuestionComponent.vue?vue&type=template&id=91c7ab48"
import script from "./ConfigQuestionComponent.vue?vue&type=script&lang=js"
export * from "./ConfigQuestionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports